// API Configuration
const API_CONFIG = {
  development: {
    baseURL: "http://localhost:5000/api",
    timeout: 10000,
  },
  production: {
    baseURL: "http://ec2-13-62-76-16.eu-north-1.compute.amazonaws.com:5000/api",
    timeout: 15000, // Longer timeout for production
  },
};

// Get current environment
const currentEnv = process.env.NODE_ENV || 'development';

// Check if we're running through ngrok
const isNgrok = window.location.hostname.includes('ngrok-free.app') || 
                window.location.hostname.includes('ngrok.io');

const deriveUploadsBaseUrl = (apiBase) => {
  if (!apiBase) {
    return "";
  }
  if (apiBase.endsWith("/api")) {
    return apiBase.replace(/\/api$/, "/uploads");
  }
  return `${apiBase.replace(/\/$/, "")}/uploads`;
};

// Use ngrok domain for API calls when accessed through ngrok
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  if (isNgrok && currentEnv === 'development') {
    return `${window.location.protocol}//${window.location.hostname}/api`;
  }
  if (currentEnv === 'production' && window?.location?.origin) {
    return `${window.location.origin}/api`;
  }
  return API_CONFIG[currentEnv].baseURL;
};

// Export current config
export const API_BASE_URL = getApiBaseUrl();
export const API_TIMEOUT = API_CONFIG[currentEnv].timeout;
export const UPLOADS_BASE_URL = process.env.REACT_APP_UPLOADS_BASE_URL || deriveUploadsBaseUrl(API_BASE_URL);

// Export full config for debugging
export const getApiConfig = () => API_CONFIG[currentEnv];

export default API_CONFIG[currentEnv]; 